import {
  Box,
  Card,
  Flex,
  Grid,
  Heading,
  IconButton,
  VStack,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../utils/Loader/Loader";
import Layout from "../Layout/Layout";
import CallWidgetCustomizeForm from "./CallWidgetCustomizeForm";
import CallVisualRepresentation from "./CallWidgetVisualRepresentation";
import useWidgetForm from "./useWidgetForm";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useContext } from "react";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
export default function CallWidgetCustomizePage() {
  const { widgetId } = useParams();
  const navigate = useNavigate();
  const agency = useContext(AgencyContext);
  const { textColor } = agency;

  const { widget, loading, widgetForm } = useWidgetForm(widgetId);
  const fields = widget?.fields || [];
  const restWidgetFields = widgetForm.watch();

  return (
      <VStack h="100%" spacing={2} borderRadius="md">
        <Flex direction={"column"} gap={3} w={"100%"} h={"100%"}>
          <Flex gap={2} w={"100%"} alignItems="center" py={2}>
            <IconButton
              icon={<IoMdArrowRoundBack />}
              variant="outline"
              size="sm"
              onClick={() => navigate(-1)}
            />
            <Heading color={textColor} fontSize="xl">
              {"Customize Widget"}
            </Heading>
          </Flex>
          {loading ? (
            <Loader />
          ) : widget ? (
            <Card p={4} h={"100%"} w={"100%"} overflowY={"auto"}>
              <Grid
                gap={4}
                gridTemplateColumns={"1fr 1fr"}
                h={"100%"}
                overflowY={"auto"}
              >
                <Box>
                  <Box bg={"white"} borderRadius={"md"} p={4}>
                    <CallWidgetCustomizeForm
                      form={widgetForm}
                      widget={widget}
                    />
                  </Box>
                </Box>
                <Box>
                  <Box
                    style={{ ...(restWidgetFields.theme?.app || {}) }}
                    border={"1px solid lightgray"}
                    borderRadius={"md"}
                  >
                    <CallVisualRepresentation
                      widgetFields={{ fields, ...restWidgetFields }}
                    />
                  </Box>
                </Box>
              </Grid>
            </Card>
          ) : (
            <Box>Widget not found</Box>
          )}
        </Flex>
      </VStack>
  );
}
